import script from "./RecoverView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecoverView.vue?vue&type=script&setup=true&lang=ts"

import "./RecoverView.vue?vue&type=style&index=0&id=152b80b7&lang=postcss"

const __exports__ = script;

export default __exports__